import { CalendarOutlined, EyeOutlined, KeyOutlined, TranslationOutlined } from "@ant-design/icons"
import { Button, DatePicker, Select, Typography } from "antd"
import { useState } from "react"
import logoEn from "../../../../public/images/logo-en.png"
import logoVi from "../../../../public/images/logo-vi.png"

import dayjs from "dayjs"
import { t } from "~/languages/i18n"

const { Text } = Typography

interface StatusPublishProps {
  setStatus: (status: string) => void
  status: string
}

interface DatePublishProps {
  setPublishDate: (date: string) => void
  initialDate?: string | null
}

interface LanguagePublishProps {
  language: string
  setLanguages: (language: string) => void
  isCreateEdit: boolean
}

export const StatusPublish = ({ setStatus, status }: StatusPublishProps) => {
  const [tempStatus, setTempStatus] = useState(status)
  const [isEditing, setIsEditing] = useState(false)

  const handleEditClick = () => {
    setIsEditing(true)
  }

  const handleCancelClick = () => {
    setIsEditing(false)
    setTempStatus(status)
  }

  const handleChange = (value: any) => {
    // setTempStatus(value.value)
    setStatus(value.value)
  }

  const handleOkClick = () => {
    setStatus(tempStatus)
    setIsEditing(false)
  }

  return (
    <div>
      <Text className="text-sm">
        <KeyOutlined /> {t("Status")}:
        <Select
          labelInValue
          className="w-fit ml-2"
          onChange={handleChange}
          options={[
            { value: "Draft", label: t("Draft") },
            { value: "Publish", label: t("Publish") },
          ]}
          value={{ value: status, label: t(status) }}
        />
      </Text>

      {isEditing && (
        <div className="mt-2">
          <Select
            labelInValue
            defaultValue={{ value: status }}
            className="w-[100px]"
            onChange={handleChange}
            options={[
              { value: "Draft", label: t("Draft") },
              { value: "Publish", label: t("Publish") },
            ]}
          />
          <Button className="ml-2" type="primary" onClick={handleOkClick}>
            {t("Ok")}
          </Button>
          <span className="text-blue-500 underline cursor-pointer ml-2" onClick={handleCancelClick}>
            {t("Cancel")}
          </span>
        </div>
      )}
    </div>
  )
}

export const LanguagePublish = ({ language, setLanguages, isCreateEdit }: LanguagePublishProps) => {
  const [tempStatus, setTempStatus] = useState(language)
  const [isEditing, setIsEditing] = useState(false)

  const handleEditClick = () => {
    setIsEditing(true)
  }

  const handleCancelClick = () => {
    setIsEditing(false)
    setTempStatus(language)
  }

  const handleChange = (value: any) => {
    setLanguages(value.value)
  }

  const handleOkClick = () => {
    setLanguages(tempStatus)
    setIsEditing(false)
  }
  return (
    <div>
      <Text className="text-sm space-x-3">
        <TranslationOutlined /> {t("Language")}:
        <Select
          labelInValue
          className="w-fit"
          onChange={handleChange}
          options={[
            {
              value: "vi",
              label: (
                <div className="flex items-center gap-2">
                  <img src={logoVi} alt="Vietnamese" className="w-5 h-5" />
                  VI
                </div>
              ),
            },
            {
              value: "en",
              label: (
                <div className="flex items-center gap-2">
                  <img src={logoEn} alt="English" className="w-5 h-5" />
                  EN
                </div>
              ),
            },
          ]}
          defaultValue={language ? { value: language } : undefined}
          disabled={isCreateEdit ? false : true}
          loading={!language}
        />
      </Text>
    </div>
  )
}

export const VisibilityPublish = () => {
  return (
    <div>
      <Text className="text-sm">
        <EyeOutlined /> {t("Visibility")}:<span className="ml-2">{t("Public")}</span>
        <a href="#" className="text-blue-500 underline cursor-pointer ml-2">
          {t("View")}
        </a>
      </Text>
    </div>
  )
}

export const DatePublish = ({ setPublishDate, initialDate }: DatePublishProps) => {
  const initialMoment = initialDate ? dayjs(initialDate) : dayjs()

  const [isEditing, setIsEditing] = useState(false)
  const [selectedDate, setSelectedDate] = useState<dayjs.Dayjs>(initialMoment)

  const handleEditClick = () => setIsEditing(true)
  const handleCancelClick = () => {
    setSelectedDate(initialMoment)
    setIsEditing(false)
  }

  const handleOkClick = () => {
    const formattedDate = selectedDate.format("YYYY-MM-DDTHH:mm:ss.sssZ")
    setPublishDate(formattedDate)
    setIsEditing(false)
  }

  const handleDateChange = (date: dayjs.Dayjs | null) => {
    if (date) {
      setSelectedDate(date)
      const formattedDate = date.format("YYYY-MM-DDTHH:mm:ss.sssZ")
      setPublishDate(formattedDate)
    }
  }

  const displayDate = selectedDate.format("DD/MM/YYYY")

  return (
    <div>
      <Text className="text-sm">
        <CalendarOutlined /> {t("Publish")}:
        <span className="ml-2 text-xs">{displayDate}</span>
        {!isEditing && (
          <span className="text-blue-500 underline cursor-pointer ml-2" onClick={handleEditClick}>
            {t("Edit")}
          </span>
        )}
      </Text>

      {isEditing && (
        <div className="mt-2 flex items-center gap-2">
          <DatePicker
            value={selectedDate}
            onChange={handleDateChange}
            format="DD/MM/YYYY"
            placeholder="Chọn ngày"
            allowClear={false}
          />
          <Button type="primary" size="small" onClick={handleOkClick}>
            {t("Ok")}
          </Button>
          <span className="text-blue-500 underline cursor-pointer" onClick={handleCancelClick}>
            {t("Cancel")}
          </span>
        </div>
      )}
    </div>
  )
}
